import { useState, useMemo } from 'react';
import { HandleAnalysisChange, ExtendedVibrationTable } from 'components/Evidences/Helpers/helper';
import { useVibrationAnalysisQuery } from 'queries/externalReferences/queries';
import { VibrationTable } from 'queries/externalReferences/contract';
export const EVIDENCE_DEFAULT_PERIOD = '730';
export const useVibrationAnalysis = (assetId: string, activeTab?: string) => {
  const [period, setPeriod] = useState(EVIDENCE_DEFAULT_PERIOD);
  const [selections, setSelections] = useState<Record<string, boolean>>({});
  const { data, isLoading } = useVibrationAnalysisQuery(assetId, period, {
    enabled: activeTab === 'VIBRATION_ANALYSIS',
  });

  //endpoint getEditedVibrationAnalysis ainda não existe - alterar pelo correto quando estiver pronto
  const { data: editedVibrationAnalysisData } = useVibrationAnalysisQuery(assetId, period, {
    enabled: activeTab === 'VIBRATION_ANALYSIS',
  });

  const filteredData = useMemo(() => {
    if (!data) return [];

    return (data as VibrationTable[]).map((row) => {
      const description = row.id;
      const newRow = { ...row } as ExtendedVibrationTable;

      Object.keys(newRow).forEach((columnKey) => {
        if (columnKey !== 'id') {
          const selectionKey = `${description}_${columnKey}`;
          if (selections[selectionKey]) {
            newRow[`selected_${columnKey}` as keyof ExtendedVibrationTable] = true as never;
          }
        }
      });

      return newRow;
    });
  }, [data, selections]);

  const hasAnySelectedCells = useMemo(() => {
    return Object.values(selections).some((selected) => selected);
  }, [selections]);

  const handleCellSelectionChange = ({ description, columnKey, value }: HandleAnalysisChange) => {
    const selectionKey = `${description}_${columnKey}`;
    setSelections((prev) => ({
      ...prev,
      [selectionKey]: value,
    }));
  };

  const handlePeriodChange = (value: string) => {
    setPeriod(value);
    setSelections({});
  };

  const clearSelections = () => {
    setSelections({});
  };

  return {
    period,
    filteredData,
    hasAnySelectedCells,
    handleCellSelectionChange,
    handlePeriodChange,
    clearSelections,
    isLoading,
    editedVibrationAnalysisData,
  };
};
